import { OrganizationSubType } from '@api/organization/@shared/organization.entity';
import { publicFilterFieldsConfig } from '@api/organization/@shared/public-fields.config';
import { OrganizationFilterForm } from 'src/app/@shared/form/form.types';

const INTERNAL_ONLY_FILTER_FIELDS_BY_SUB_TYPE: Partial<Record<OrganizationSubType, (keyof OrganizationFilterForm)[]>> = {
  selfHelpAddressCommunity: ['searchForms'],
  selfHelpAddressShGroup: ['searchForms'],
};

export const SUB_TYPE_GATED_ORGANIZATION_FILTER_FIELDS: (keyof OrganizationFilterForm)[] = [
  'language',
  'searchForms',
  'stateLevelSubdivisions',
  'targetGroup',
];

export function isInternalOrganizationFilterFieldAvailable(
  field: keyof OrganizationFilterForm,
  subTypes: OrganizationSubType[],
): boolean {
  if (!SUB_TYPE_GATED_ORGANIZATION_FILTER_FIELDS.includes(field) || !subTypes.length) {
    return true;
  }

  return subTypes.some((subType) => {
    return publicFilterFieldsConfig[subType]?.includes(field)
      || INTERNAL_ONLY_FILTER_FIELDS_BY_SUB_TYPE[subType]?.includes(field);
  });
}
